import styled from 'styled-components';
import colors from 'styles/colors';

import { DropdownMenuContent, DropdownMenuItem } from 'components/DropdownMenu/DropdownMenu.styles';

import { ACTIVE } from 'styles/commonClasses';

import { Input } from 'styles/form';

export const SearchIcon = styled.span`
  color: ${colors.gray70};
  font-size: 16px;
  position: absolute;
  left: 9px;
`;

export const Search = styled(Input)`
  border: 1px solid ${colors.gray70};
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  padding-left: 36px;
  text-transform: capitalize;
  transition: width 0.25s ease-in-out;
  width: 250px;

  ::placeholder {
    color: ${colors.gray70};
  }
`;

export const SearchWrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  align-items: center;

  &.${ACTIVE} ${SearchIcon} {
    color: ${colors.highlight};
  }
`;

export const DropdownSearchMenuContent = styled(DropdownMenuContent)`
  top: 35px;
  padding: 0;
  width: 100%;

  ${DropdownMenuItem} {
    font-weight: normal;
    min-height: 30px;
    height: auto;
    padding-top: 5px;
    padding-bottom: 5px;
    white-space: pre-wrap;

    &:hover {
      color: ${colors.primary};
      background-color: ${colors.activeLight};
    }
  }
`;
